export enum ICONTYPE {
  PI = 'pi',
  FAS = 'fas',
  FAB = 'fab',
}
